import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"16\" height=\"16\" fill=\"url(#paint0_radial_9894_2781)\" rx=\"4\"></rect><path fill=\"#fff\" d=\"M9.72 11.703v-3.76L8 9.999 6.28 7.943v3.76H4V4.297h2.16L8 6.68l1.844-2.383H12v7.406z\"></path><defs><radialGradient id=\"paint0_radial_9894_2781\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"rotate(130.469 7.368 3.185)scale(21.7054)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#FF7067\"></stop><stop offset=\".464\" stop-color=\"#F13E33\"></stop><stop offset=\".714\" stop-color=\"#ED0E00\"></stop><stop offset=\"1\" stop-color=\"#FFAFAA\"></stop></radialGradient></defs>", 3)
  ])))
}
export default { render: render }